import { LocalizedError } from "./localized-error";
import { TransTokens } from "../i18n/trans-tokens";

const tokens = TransTokens.create({
  NotLoggedIn: "You are not logged in.",
});

export class UnauthenticatedError extends LocalizedError {
  constructor(underlyingError?: Error) {
    super(underlyingError, tokens.NotLoggedIn);
  }
}
